<ion-header class="outer-nav-header">
  <div class="upgrade-feature-banner" *ngIf="!featureEnabled">
    <div class="constrained-content flex-space-between" style="align-items: center">
      Upgrade to send bulk messages across your Slack channels
      <ion-button fill="outline" color="light" class="btn-small" [routerLink]="'/upgrade'">
        <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
        Upgrade account
      </ion-button>
    </div>
  </div>

  <ion-toolbar class="constrained-content">
    <div class="flex-space-between">
      <ion-buttons>
        <ion-button (click)="dismiss()" [disabled]="isSaving">
          <ion-icon name="chevron-back-outline" class="icon-padded-right"></ion-icon>
          <span class="hidden-sm">Back</span>
        </ion-button>
      </ion-buttons>
      <div class="nav-container">
        <span
          class="tab-nav-link"
          (click)="selectedTab = 'message'"
          [ngClass]="{'tab-nav-active': selectedTab === 'message' }"
        >
          Message
        </span>
        <span
          class="tab-nav-link"
          (click)="selectedTab = 'recipients'"
          [ngClass]="{'tab-nav-active': selectedTab === 'recipients' }"
        >
          Recipients
        </span>
        <span
          class="tab-nav-link"
          (click)="selectedTab = 'send'"
          [ngClass]="{'tab-nav-active': selectedTab === 'send' }"
        >
          <span class="hidden-sm"> Review & Send </span>
          <span class="shown-sm"> Send </span>
        </span>
      </div>
      <ion-buttons>
        <ion-button (click)="showAnalytics()" [disabled]="isSaving" *ngIf="isSent">
          <ion-icon name="stats-chart"></ion-icon>
          <span class="hidden-sm text-with-left-icon">Analytics</span>
        </ion-button>
        <ion-button (click)="showOptions()" [disabled]="isSaving">
          <ion-icon name="ellipsis-vertical"></ion-icon>
          <span class="hidden-sm">Options</span>
        </ion-button>
      </ion-buttons>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class="constrained-content main-grid">
    <ng-container *ngIf="!isLoading">
      <div [hidden]="selectedTab !== 'message'">
        <h3>Compose Broadcast</h3>
        <app-slack-blocks
          #slackBlocks
          [blocks]="blocks"
          [communityId]="null"
          (blocksChanged)="blocksChanged()"
          [sendAs]="sendAs"
          [disabled]="isSent"
          (sendAsChanged)="sendAsChanged($event)"
        >
        </app-slack-blocks>
      </div>

      <div [hidden]="selectedTab !== 'recipients'">
        <h3>Recipients</h3>
        <ion-row>
          <ion-col size="6" [hidden]="isSent">
            <ion-card class="outline-card send-card">
              <ion-searchbar
                mode="ios"
                placeholder="Search..."
                showCancelButton="never"
                [(ngModel)]="searchText"
                (ionChange)="handleFilters()"
              >
              </ion-searchbar>
              <div style="display: flex; align-items: center; padding: 0 10px">
                <app-filter-button [options]="filterOptions" (didChange)="filtersDidChange($event)"></app-filter-button>
                <ion-button
                  color="dark"
                  fill="clear"
                  class="btn-small"
                  (click)="showArchivedCustomers = !showArchivedCustomers; loadCustomers()"
                >
                  <ion-icon
                    [name]="showArchivedCustomers ? 'checkmark-circle' : 'ellipse-outline'"
                    class="padded-icon checkbox-icon"
                  >
                  </ion-icon>
                  Show archived
                </ion-button>
              </div>
              <ngx-datatable
                class="material"
                columnMode="force"
                [limit]="100"
                [headerHeight]="50"
                [footerHeight]="50"
                [rowHeight]="50"
                [scrollbarH]="true"
                [rows]="filteredCustomers"
                [selected]="recipients"
                selectionType="checkbox"
                [selectAllRowsOnPage]="false"
                [displayCheck]="false"
                [reorderable]="true"
                [loadingIndicator]="isLoadingCustomers"
                (select)="onSelect($event)"
              >
                <ngx-datatable-column
                  [width]="30"
                  [sortable]="false"
                  [canAutoResize]="false"
                  [draggable]="false"
                  [resizeable]="false"
                  [headerCheckboxable]="!isLoadingCustomers"
                  [checkboxable]="!isLoadingCustomers"
                >
                </ngx-datatable-column>
                <ngx-datatable-column name="Name" [minWidth]="175">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <a class="row-title row-link" (click)="toggleRowSelected(row)"> {{row.name}} </a>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Channel" prop="slackChannel?.name" [minWidth]="250">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <ion-icon name="lock-closed" *ngIf="row.slackChannel?.isPrivate"></ion-icon>
                    {{row.slackChannel?.name}}
                    <i *ngIf="!row.slackChannel?.name">None</i>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Channel members" prop="followerCount" [maxWidth]="170" [minWidth]="170">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <ion-badge color="light">{{row.followerCount}}</ion-badge>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </ion-card>
          </ion-col>
          <ion-col size="6">
            <h4 style="color: #666; font-size: 1rem; margin: 15px" [hidden]="isSent">
              {{recipients?.length ?? 0 }} selected
            </h4>
            <ion-card class="outline-card send-card">
              <div class="empty-state-container" *ngIf="!recipients?.length">
                <p class="placeholder-subtitle">
                  No customers selected<br />
                  Click the checkbox next to the customer you'd like to send to
                </p>
              </div>
              <ion-list *ngIf="recipients?.length">
                <ion-item *ngFor="let recipient of recipients; let i = index">
                  <ion-button color="danger" fill="clear" (click)="recipients.splice(i, 1)" [hidden]="isSent">
                    <ion-icon name="close-outline"></ion-icon>
                  </ion-button>
                  <ion-label> {{recipient.name}} </ion-label>
                </ion-item>
              </ion-list>
            </ion-card>
          </ion-col>
        </ion-row>
      </div>

      <div [hidden]="selectedTab !== 'send'" class="send-container">
        <div style="margin-bottom: 15px">
          <ng-container>
            <h3>Notification Preview</h3>
            <ion-card class="notification-preview">
              <div class="notification-icon">
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fslack.png?alt=media&token=979c839c-f3a5-4ccf-a2be-14314069865d"
                />
              </div>
              <div style="width: 85%">
                <div class="notification-text">
                  <strong>Slack</strong>
                </div>
                <div class="notification-text">
                  <strong>#channel</strong>
                </div>
                <ion-input
                  [placeholder]="getBackupSubject()"
                  [(ngModel)]="subject"
                  style="--padding-top: 0; --padding-bottom: 0; --padding-start: 0"
                >
                </ion-input>
                <!-- <div *ngIf="subject" class="notification-text">{{subject}}</div>
                <div *ngIf="!subject" class="notification-text">{{getBackupSubject()}}</div> -->
              </div>
            </ion-card>
          </ng-container>

          <h3>Schedule</h3>
          <ion-card class="outline-card send-card">
            <ion-card-content class="no-padding">
              <ion-radio-group [(ngModel)]="isScheduled">
                <ion-list>
                  <ion-item>
                    <ion-radio slot="start" class="item-left-accessory" [value]="false" [disabled]="isSent"></ion-radio>
                    <ion-label text-wrap>Send immediately</ion-label>
                  </ion-item>
                  <ion-item>
                    <ion-radio slot="start" class="item-left-accessory" [value]="true" [disabled]="isSent"></ion-radio>
                    <ion-label text-wrap>Send later (max 30 days)</ion-label>
                  </ion-item>
                </ion-list>
              </ion-radio-group>
              <div *ngIf="isScheduled" style="margin: -8px 12px 12px 46px">
                <app-datetime-picker
                  [initialDate]="getInitialDate()"
                  [initialTime]="getInitialTime()"
                  (datetimeChanged)="setRunAt($event)"
                  [disabled]="isSent"
                  [toDate]="maxDate"
                >
                </app-datetime-picker>
              </div>
            </ion-card-content>
          </ion-card>

          <h3>Send As</h3>
          <ion-card class="outline-card send-card">
            <ion-card-content class="no-padding">
              <ion-radio-group [(ngModel)]="sendAs.type">
                <ion-list>
                  <ion-item>
                    <ion-radio slot="start" class="item-left-accessory" value="user" [disabled]="isSent"></ion-radio>
                    <ion-label text-wrap>Send as yourself</ion-label>
                  </ion-item>
                  <ion-item>
                    <ion-radio
                      slot="start"
                      class="item-left-accessory"
                      value="support-rep"
                      [disabled]="isSent"
                    ></ion-radio>
                    <ion-label text-wrap> Primary support rep for customer (defaults to you if none is set) </ion-label>
                  </ion-item>
                  <ion-item>
                    <ion-radio
                      slot="start"
                      class="item-left-accessory"
                      value="support-team"
                      [disabled]="isSent"
                    ></ion-radio>
                    <ion-label text-wrap> Support team </ion-label>
                  </ion-item>
                </ion-list>
              </ion-radio-group>
            </ion-card-content>
          </ion-card>

          <h3>Options</h3>
          <ion-card class="outline-card send-card">
            <ion-card-content class="no-padding">
              <ion-list>
                <ion-item>
                  <ion-checkbox
                    slot="start"
                    class="item-left-accessory"
                    [(ngModel)]="unfurlLinks"
                    [disabled]="isSent"
                  ></ion-checkbox>
                  <ion-label text-wrap>Expand link previews?</ion-label>
                </ion-item>
              </ion-list>
            </ion-card-content>
          </ion-card>
        </div>
        <ng-container *ngIf="!outbound || outbound.status !== 'sent'">
          <ion-button
            size="block"
            class="btn-large send-button"
            (click)="send()"
            [disabled]="isSaving || !featureEnabled"
            *ngIf="recipients.length"
          >
            {{isScheduled ? 'Schedule send' : 'Send'}}
            <ion-icon name="send-outline" class="icon-padded-left" [hidden]="isSaving"></ion-icon>
            <ion-spinner name="crescent" style="margin-left: 8px" [hidden]="!isSaving"></ion-spinner>
          </ion-button>
          <ion-button
            size="block"
            color="warning"
            class="btn-large send-button"
            (click)="selectedTab = 'recipients'"
            *ngIf="!recipients.length"
          >
            Select recipients to send
          </ion-button>
        </ng-container>
        <ng-container *ngIf="!outbound || outbound.status === 'draft'">
          <ion-button
            size="block"
            fill="clear"
            class="send-button"
            (click)="sendTest()"
            [disabled]="isSaving || isSendingTest"
          >
            Send test to myself
            <ion-spinner name="crescent" style="margin-left: 8px" [hidden]="!isSendingTest"></ion-spinner>
          </ion-button>
          <ion-button
            size="block"
            fill="clear"
            class="send-button"
            (click)="saveAsDraft()"
            [disabled]="isSaving || isSendingTest"
          >
            Save draft
          </ion-button>
          <ion-button size="block" fill="clear" color="dark" disabled="true" style="font-weight: 400">
            {{ getDraftSaveDateDisplay() }}
          </ion-button>
        </ng-container>
        <ion-button
          size="block"
          class="btn-large send-button"
          [disabled]="true"
          *ngIf="outbound && outbound.status === 'sent'"
        >
          <ion-icon name="checkmark-outline" class="padded-icon"></ion-icon>
          Sent
        </ion-button>
      </div>

      <div
        style="text-align: right; padding: 20px; bottom: 0; position: sticky; pointer-events: none"
        [hidden]="selectedTab === 'send'"
      >
        <div style="width: fit-content; margin-right: 0; margin-left: auto; pointer-events: auto">
          <ion-button fill="clear" color="dark" disabled="true" style="font-weight: 400" [hidden]="isSent">
            {{ getDraftSaveDateDisplay() }}
          </ion-button>
          <ion-button fill="clear" style="margin-right: 10px" (click)="saveAsDraft()" [hidden]="isSent">
            Save draft
          </ion-button>
          <ion-button fill="clear" style="margin-right: 10px" (click)="sendTest()" [hidden]="isSent">
            Send test to myself
          </ion-button>
          <ion-button (click)="nextStep()">
            Next <ion-icon name="chevron-forward-outline" class="icon-padded-left"></ion-icon>
          </ion-button>
        </div>
      </div>
    </ng-container>

    <div style="text-align: center; margin-top: 60px" *ngIf="isLoading">
      <ion-spinner name="crescent" class="fullscreen-spinner"></ion-spinner>
    </div>
  </ion-grid>
</ion-content>
